import { useState } from "react";
import {
  Button,
  Card,
  Flex,
  Heading,
  Text,
  TextField,
} from "@radix-ui/themes";
import { signIn } from "../auth/client";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    const res = await signIn.email({ email, password });
    if (res.error) {
      setBusy(false);
      setError(res.error.message ?? "Sign-in failed");
      return;
    }
    // Full reload so the session cookie is present for the first API calls.
    window.location.assign("/");
  }

  return (
    <div className="hq-login">
      <Card className="hq-login__card" size="3">
        <form onSubmit={onSubmit}>
          <Flex direction="column" gap="3">
            <Flex direction="column" gap="1">
              <Heading size="6" as="h1">
                whtvrwrks · hq
              </Heading>
              <Text size="2" className="hq-muted">
                Admin console — sign in to continue.
              </Text>
            </Flex>

            <label>
              <Text size="1" color="gray" mb="1" as="div">
                Email
              </Text>
              <TextField.Root
                type="email"
                required
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                size="2"
              />
            </label>

            <label>
              <Text size="1" color="gray" mb="1" as="div">
                Password
              </Text>
              <TextField.Root
                type="password"
                required
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                size="2"
              />
            </label>

            <Button type="submit" disabled={busy} loading={busy}>
              Sign in
            </Button>

            {error && (
              <Text size="2" color="red">
                {error}
              </Text>
            )}
          </Flex>
        </form>
      </Card>
    </div>
  );
}
